import { useState } from 'react';

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const MOCK_DB = [
  { id: 1, plaque: 'ABC 1234', entree: '22:14', reglement: 'Espèces', depart: '06h00', statut: 'présent' },
  { id: 2, plaque: 'TUN 7821', entree: '23:02', reglement: 'CB',      depart: '07h30', statut: 'présent' },
  { id: 3, plaque: 'FR-892-KL', entree: '20:45', reglement: 'Espèces', depart: '05h00', statut: 'dépassé' },
];



export default function VueRecherche() {
  const [query,   setQuery]   = useState('');
  const [results, setResults] = useState([]);
  const [searched,setSearched]= useState(false);

  const handleSearch = () => {
    if (!query.trim()) return;
    setSearched(true);
    const q = query.trim().toLowerCase();
    setResults(MOCK_DB.filter(c => c.plaque.toLowerCase().includes(q)));
    // TODO: axios.get(`/api/camions/search?plaque=${query}`)
  };

  return (
    <>
      <div className="vv-page-header">
        <div>
          <div className="vv-page-title">Recherche plaque</div>
          <div className="vv-page-sub">Retrouver un camion par immatriculation</div>
        </div>
      </div>

      <div className="vv-content">
        <div className="vv-panel">
          <div style={{ display: 'flex', gap: '8px', marginBottom: '1.5rem' }}>
            <div className="vv-search" style={{ flex: 1, marginBottom: 0 }}>
              <SearchIcon />
              <input
                type="text"
                placeholder="Saisir une plaque (ex: ABC 1234)…"
                value={query}
                onChange={e => setQuery(e.target.value.toUpperCase())}
                onKeyDown={e => e.key === 'Enter' && handleSearch()}
                style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: '15px', letterSpacing: '0.06em' }}
              />
            </div>
            <button className="vv-btn vv-btn-primary" onClick={handleSearch}>
              <SearchIcon /> Rechercher
            </button>
          </div>

          {!searched && (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--pg-text-muted)', fontSize: '13px' }}>
              Saisissez une plaque pour rechercher un camion
            </div>
          )}

          {searched && results.length === 0 && (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--pg-text-muted)', fontSize: '13px' }}>
              Aucun camion trouvé pour « {query} »
            </div>
          )}

          {results.length > 0 && (
            <div className="vv-camion-list">
              {results.map(c => (
                <div key={c.id} className="vv-camion-row" style={{ gridTemplateColumns: '1fr auto' }}>  

                  <div>
                    <div className="vv-camion-plaque">{c.plaque}</div>
                    <div className="vv-camion-meta">
                      Entrée {c.entree} · {c.reglement} · Départ estimé {c.depart}
                    </div>
                  </div>

                  
                  <span
                    style={{
                      fontSize: '11px', padding: '3px 10px', borderRadius: '99px',
                      background: c.statut === 'présent' ? 'var(--pg-green-dim)' : 'var(--pg-red-dim)',
                      color: c.statut === 'présent' ? 'var(--pg-green)' : '#f87171',
                      border: `1px solid ${c.statut === 'présent' ? 'rgba(34,197,94,0.3)' : 'rgba(239,68,68,0.3)'}`,
                    }} 
                      >
                    {c.statut}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}






